// START_MODULE app_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { route } from './routes/route';
import MainPage from './pages/main/MainPage';
import NewsPage from './pages/news/list/NewsPage';
import Footer from './components/organisms/footer/Footer';
import NewsDetailsPage from './pages/news/details/NewsDetailsPage';

const App = () => (
  <>
    <div style={{ flexGrow: 1 }}>
      <Routes>
        <Route path={route.base} element={<MainPage />} />
        <Route path={route.news} element={<NewsPage />} />
        <Route path={route.newsDetails()} element={<NewsDetailsPage />} />
      </Routes>
    </div>
    <Footer />
  </>
);

export default App;

// END_MODULE app_tsx
